// extracted by mini-css-extract-plugin
module.exports = {"deviceBox":"device_deviceBox__3cEgJ","deviceLink":"device_deviceLink__1oIty","deviceImg":"device_deviceImg__2cwmS","title":"device_title__2Ek7w"};